import {appConfig} from "./app-config";

export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}


export const loadFile = (fileName) => {
  // File could be a blob
  const dataCheck = /^\s*data:/;
  if(dataCheck.test(fileName)) {
      return fileName
  }

   // File could be from AWS
  const awsCheck = /\.amazonaws\.com/;
  if(awsCheck.test(fileName)) {
      return fileName
  }

   // File could be from the direct file system
  return appConfig.getAPIBase().replace('/api/rest', '') + '/uploads/' +  fileName;
}

/**
 * Cleans a username by converting to lowercase and removing spaces.
 * @param username
 * @returns {*}
 */
export const usernameClean = (username) => {
  return username.toLowerCase().replace(/\s/g, '');
}
